import { Injectable } from '@angular/core';

import { Group } from '../../model/tenant/group';
import { UserService } from '../../service/user/user.service';
import { DeptTreeNode } from './dept-tree-node';

@Injectable()
export class DeptTreeService {
  constructor(private userService: UserService) {
  }

  /**
   * ç»è£é¨é¨æ åä¸ªèç¹
   */
  private getDeptTreeNode(dept: Group) {
    return new DeptTreeNode(dept);
  }

  /**
   * ç§å®¤Listè·å
   */
  getDeptList() {
    let depts: DeptTreeNode[] = [];
    this.userService.getDepts().forEach((item) => {
      depts.push(this.getDeptTreeNode(item));
    });
    return depts;
  }

  /**
   * å°ç»Listè·å
   */
  getGroupList() {
    let groups: DeptTreeNode[] = [];
    this.userService.getGroups().forEach((item) => {
      groups.push(this.getDeptTreeNode(item));
    });
    return groups;
  }

  /**
   * é¨é¨æ è·å
   */
  getDeptTree(onlyDept?: boolean) {
    if (onlyDept) {
      return this.composeDeptTree(this.getDeptList(), []);
    } else {
      return this.composeDeptTree(this.getDeptList(), this.getGroupList());
    }
  }

  /**
   * ç»è£æ´æ£µé¨é¨æ 
   */
  private composeDeptTree(depts: DeptTreeNode[], groups: DeptTreeNode[] = []) {
    let newDepts: DeptTreeNode[] = [];
    if (depts instanceof Array) {
      // è·åææé¨é¨æ ¹èç¹
      for (let i = depts.length - 1; i >= 0; i--) {
        if (depts[i].data.parentId == null
          || depts[i].data.parentId === 0
          || !this.isExistParent(depts, depts[i].data.parentId)
        ) {
          newDepts.push(depts[i]);
        }
      }
      // æåº
      newDepts.sort((a, b) => (b.data.idx - a.data.idx));
      newDepts.forEach((item) => {
        this.packageDeptTree(item, depts);
      });
    }
    groups.sort((a, b) => (b.data.idx - a.data.idx));
    return newDepts.concat(groups);
  }

  /**
   * éå½ç»è£é¨é¨æ 
   */
  private packageDeptTree(node: DeptTreeNode, depts: DeptTreeNode[]) {
    for (let i = depts.length - 1; i > -1; i--) {
      if (depts[i].data.parentId === node.data.id) {
        node.children.push(depts[i]);
      }
    }
    node.children.sort((a, b) => (b.data.idx - a.data.idx));
    // éå½ç»è£
    if (node.children.length > 0) {
      node.children.forEach((item) => {
        this.packageDeptTree(item, depts);
      });
    }
  }

  /**
   * æ¯å¦ä¸ºæ ¹èç¹
   */
  private isExistParent(depts: DeptTreeNode[], deptParentId: number) {
    let exist = false;
    depts.forEach((item) => {
      if (item.data.id === deptParentId) {
        exist = true;
      }
    });
    return exist;
  }

  /**
   * æç´¢é¨é¨
   */
  searchDeptsByText(searchText: string, onlyShowDept: boolean = false): DeptTreeNode[] {
    let depts = this.userService.getDepts();
    let groups = onlyShowDept ? [] : this.userService.getGroups();
    let result = [];
    depts.forEach(item => {
      if (item.name.toUpperCase().indexOf(searchText.toUpperCase()) > -1) {
        result.push(this.getDeptTreeNode(item));
      }
    });
    groups.forEach(item => {
      if (item.name.toUpperCase().indexOf(searchText.toUpperCase()) > -1) {
        result.push(this.getDeptTreeNode(item));
      }
    });
    return result;
  }

  /**
   * è¿æ»¤ååç©ºæ ¼
   */
  filterSpace(text: string) {
    return text.replace(/(^\s*)/g, '').replace(/(\s*$)/g, '');
  }


  /**
   * å±å¼å½åèç¹
   */
  expandRecursive(node: DeptTreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach(childNode => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  expandNodes(deptNodes: DeptTreeNode[], expandedNodes: DeptTreeNode[], isExpand: boolean) {
    expandedNodes.forEach(node => this.expandNode(deptNodes, node, isExpand));
  }

  expandNode(deptNodes: DeptTreeNode[], expandedNode: DeptTreeNode, isExpand: boolean) {
    if (deptNodes.length === 0) {
      return;
    }
    for (let i = 0; i < deptNodes.length; i++) {
      if (expandedNode.data.id === deptNodes[i].data.id) {
        deptNodes[i].expanded = isExpand;
        return;
      }
      if (deptNodes[i].children.length > 0) {
        this.expandNode(deptNodes[i].children, expandedNode, isExpand);
      }
    }
  }

  getSingleSelectedNode(deptNodes: DeptTreeNode[] = [], selectedNode: DeptTreeNode): DeptTreeNode {
    if (!selectedNode) {
      return undefined;
    }
    let results: DeptTreeNode[] = [];
    this.findNodes(deptNodes, [selectedNode], results);
    return results[0];
  }

  getMultiSelectedNodes(deptNodes: DeptTreeNode[] = [], selectedNodes: DeptTreeNode[]): DeptTreeNode[] {
    if (!selectedNodes) {
      return [];
    }
    let results: DeptTreeNode[] = [];
    this.findNodes(deptNodes, selectedNodes, results);
    return results;
  }

  getShowName(nodes: DeptTreeNode[]): string {
    nodes = nodes || [];
    return nodes.map(node => node.label).join('ã');
  }

  selectAllNode(nodes: DeptTreeNode[], selectedDeptNodes: DeptTreeNode[]) {
    nodes = nodes || [];
    if (nodes.length === 0) {
      return;
    }
    nodes.filter(node => node.selectable || node.selectable !== false).forEach(node => selectedDeptNodes.push(node));
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].children.length > 0) {
        this.selectAllNode(nodes[i].children, selectedDeptNodes);
      }
    }
  }

  cancelSelectAllNode(nodes: DeptTreeNode[], selectedDeptNodes: DeptTreeNode[]) {
    nodes = nodes || [];
    selectedDeptNodes = selectedDeptNodes || [];
    if (nodes.length === 0) {
      return;
    }
    for (let i = selectedDeptNodes.length - 1; i > -1; i--) {
      if (nodes.find(selectedNode => selectedNode.data.id === selectedDeptNodes[i].data.id)) {
        selectedDeptNodes.splice(i, 1);
      }
    }

    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].children.length > 0) {
        this.cancelSelectAllNode(nodes[i].children, selectedDeptNodes);
      }
    }
  }

  isAllSelected(selectedNodes: DeptTreeNode[], allNodes: DeptTreeNode[]): boolean {
    selectedNodes = selectedNodes || [];
    allNodes = allNodes || [];
    if (selectedNodes.length === 0) {
      return false;
    }
    return this.findNodesCount(selectedNodes, allNodes, null);
  }

  private findNodesCount(selectedNodes: DeptTreeNode[], deptNodes: DeptTreeNode[], callBack: Function) {
    for (let i = 0; i < deptNodes.length; i++) {
      if (!selectedNodes.find(selectedNode => selectedNode.data.id === deptNodes[i].data.id) && (deptNodes[i].selectable || deptNodes[i].selectable !== false)) {
        return false;
      }
    }
    for (let i = 0; i < deptNodes.length; i++) {
      if (deptNodes[i].children.length > 0) {
        return this.findNodesCount(selectedNodes, deptNodes[i].children, callBack);
      }
    }
    return true;
  }

  private findNodes(deptNodes: DeptTreeNode[], selectedNodes: DeptTreeNode[], newSelectedNodes: DeptTreeNode[]) {
    for (let i = 0; i < deptNodes.length; i++) {
      if (!!selectedNodes.find(selectedNode => selectedNode.data.id === deptNodes[i].data.id)
        && !newSelectedNodes.find(selectedNode => selectedNode.data.id === deptNodes[i].data.id)) {
        newSelectedNodes.push(deptNodes[i]);
      }
      if (deptNodes[i].children && deptNodes[i].children.length > 0) {
        this.findNodes(deptNodes[i].children, selectedNodes, newSelectedNodes);
      }
    }

    for (let i = 0; i < selectedNodes.length; i++) {
      let oneSelectNode = selectedNodes[i];
      if (!newSelectedNodes.find(selectedNode => selectedNode.data.id === oneSelectNode.data.id)) {
        newSelectedNodes.push(oneSelectNode);
      }
    }
  }
}
